import React, { useState, useEffect } from 'react';
import './SplashScreen.css'; // Import the CSS file
import MessageSVG from './Message';

const SplashScreen = () => {
    const [isBeating, setBeating] = useState(false);


    useEffect(() => {
        // Set up a timer to toggle the beating state every second
        const intervalId = setInterval(() => {
            setBeating(prevState => !prevState);
        }, 700);

        // Clean up the timer when the component unmounts
        return () => clearInterval(intervalId);
    }, []); // Empty dependency array means this effect runs once after the initial render

    return (
        <div className={`heartbeat ${isBeating ? 'beat' : ''}`}>
            <MessageSVG color={'blue'} height={300} width={300} />
        </div>
    );
};

export default SplashScreen;
